// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-m76","comment":"styles_comment__2gxAn"};